import { USER_ROLE } from '@utils/auth/roles';

export const adminRoles = [USER_ROLE.admin, USER_ROLE.superAdmin];
